// settings.py SEARCH_TERM_PARAMS: the member's search term or typed address.
const SEARCH_TERM_PARAMS = ["q", "keyword", "query", "suggest", "search"]
const FILTERED = "[Filtered]"

const UTF8 = new TextDecoder()

function unquotePlus(component) {
  return component
    .replace(/\+/g, " ")
    .replace(/(?:%[0-9A-Fa-f]{2})+/g, (escapes) =>
      UTF8.decode(Uint8Array.from(escapes.slice(1).split("%"), (hex) => Number.parseInt(hex, 16))),
    )
}

export function scrubSearchTerms(url) {
  if (typeof url !== "string" || !url.includes("?")) {
    return url
  }
  const [beforeQuery, afterQuery] = url.split(/\?(.*)/s)
  const [query, fragment] = afterQuery.split(/#(.*)/s)
  const scrubbed = query
    .split("&")
    .map((pair) => {
      const [name, ...rest] = pair.split("=")
      if (SEARCH_TERM_PARAMS.includes(unquotePlus(name))) {
        return `${name}=${FILTERED}`
      }
      const target = unquotePlus(rest.join("="))
      const scrubbedTarget = scrubSearchTerms(target)
      return scrubbedTarget === target ? pair : `${name}=${encodeURIComponent(scrubbedTarget)}`
    })
    .join("&")
  return `${beforeQuery}?${scrubbed}${fragment === undefined ? "" : `#${fragment}`}`
}

export function scrubEvent(event) {
  const request = event.request
  if (request) {
    request.url = scrubSearchTerms(request.url)
    if (request.headers?.Referer) {
      request.headers.Referer = scrubSearchTerms(request.headers.Referer)
    }
  }
  for (const exception of event.exception?.values ?? []) {
    for (const frame of exception.stacktrace?.frames ?? []) {
      frame.filename = scrubSearchTerms(frame.filename)
    }
  }
  return event
}

export function scrubBreadcrumb(breadcrumb) {
  const data = breadcrumb.data
  if (data) {
    for (const key of ["url", "from", "to"]) {
      if (key in data) {
        data[key] = scrubSearchTerms(data[key])
      }
    }
  }
  return breadcrumb
}
